<template>
  <div>
    <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="1300px" v-if="formVisible">
      <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
        <div class="reimbursement">
          <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
            <div class="title-box"><span class="txt1">商品基础信息</span></div>
            <!-- <el-form-item label="聚水潭编码：" prop="youCode">
              <el-input v-model="form.youCode" placeholder="请输入聚水潭编码" />
            </el-form-item> -->
            <el-form-item label="活动名称：" prop="name">
              <el-input v-model="form.name" placeholder="请输入活动名称" />
            </el-form-item>
            <el-form-item label="商品主图：" prop="img">
              <div class="flexs">
                <imageUpload v-model="form.img" width="32" height="32" />
                <span class="hint hint1">限制上传1张<br />建议尺寸750x750像素以上</span>
              </div>
            </el-form-item>
            <el-form-item label="商品banner图：" class="width100">
              <moreImageUpload v-model="form.bannerImg" :limit="10" hintText="建议尺寸750x750像素以上" />
            </el-form-item>
            <el-form-item label="零售价：" prop="retailPrice">
              <el-input v-model="form.retailPrice" placeholder="请输入市场价" />
            </el-form-item>
            <el-form-item label="活动价格：">
              <el-input v-model="allPrice" placeholder="自动读取正价商品总价" disabled />
            </el-form-item>
            <el-form-item label="是否限购：" prop="isQuota">
              <el-radio-group v-model="form.isQuota">
                <el-radio :label="0">不限购</el-radio>
                <el-radio :label="1">限购</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="限购数量：" v-show="form.isQuota">
              <el-input v-model="form.quotaNum" placeholder="请输入限购数量" />
            </el-form-item>
            <el-form-item label="虚拟销售量：" prop="virtualSalesCount">
              <el-input v-model="form.virtualSalesCount" placeholder="请输入虚拟销售量" />
            </el-form-item>
            <el-form-item label="秒杀份数：" prop="salesNum">
              <el-input v-model="form.salesNum" placeholder="请输入秒杀份数" />
            </el-form-item>
            <el-form-item label="是否APP端展示：" prop="isShowApp">
              <el-radio-group v-model="form.isShowApp">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否开票：" prop="canInvoice">
                <el-radio-group v-model="form.canInvoice">
                  <el-radio :label="1">支持</el-radio>
                  <el-radio :label="0">不支持</el-radio>                
                </el-radio-group>
            </el-form-item>
            <el-form-item label="取件方式：" prop="pickupMethodList" class="width100" required>
              <el-checkbox-group v-model="form.pickupMethodList">
                <el-checkbox label="express">快递</el-checkbox>
                <el-checkbox label="selfPickup">自提</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <!-- <el-form-item label="核销权限：" prop="writeoffAuthList" class="width100" v-if="pickupMethodList.includes('selfPickup')">
              <el-select
                v-model="form.writeoffAuthList"
                multiple
                filterable
                remote
                :remote-method="searchWriteoffUsers"
                :loading="writeoffUserLoading"
                placeholder="请选择核销权限"
                style="width: 100%;"
                @change="handleWriteoffAuthChange"
              >
                <el-option
                  v-for="item in writeoffUserOptions"
                  :key="`${item.userType}-${item.userInfoId}`"
                  :label="item.label"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="自提地址：" prop="pickupAddressList" class="width100" v-if="form.pickupMethodList.includes('selfPickup')" required>
              <div class="table-list">
                <div class="spec-head">
                  <div class="sp-col sp-col-name">活动名称</div>
                  <div class="sp-col sp-col-writeoffAuthNameList">核销人信息</div>
                  <div class="sp-col sp-col-address">自提地址</div>
                  <div class="sp-col sp-col-time">自提时间</div>
                  <div class="sp-col sp-col-action">操作</div>
                </div>
                <div class="spec-item" v-for="(item, index) in (form.pickupAddressList || [])" :key="index">
                  <div class="sp-col sp-col-name">
                    <el-form-item :prop="`pickupAddressList.${index}.name`" :rules="{required: true, message: '请输入活动名称', trigger: 'blur'}" style="margin-bottom: 0;">
                      <el-input v-model="item.name" placeholder="请输入活动名称" size="small" />
                    </el-form-item>
                  </div>
                  <div class="sp-col sp-col-writeoffAuthNameList">
                    <el-form-item style="margin-bottom: 0;">
                      <el-select
                        v-model="item.writeoffAuthList"
                        multiple
                        filterable
                        remote
                        :remote-method="(query) => searchWriteoffUsers(query, index)"
                        :loading="item.writeoffUserLoading"
                        placeholder="请输入关键词搜索核销人"
                        size="small"
                        style="width: 100%;"
                        value-key="userId"
                        class="writeoff-select"
                      >
                        <el-option
                          v-for="userOption in item.writeoffUserOptions"
                          :key="userOption.userId"
                          :label="`${userOption.userRealName}(${userOption.userMobile})${userOption.userLevelName ? '-' + userOption.userLevelName : ''}`"
                          :value="userOption"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="sp-col sp-col-address">
                    <el-form-item :prop="`pickupAddressList.${index}.address`" :rules="{required: true, message: '请选择地址', trigger: 'change'}" style="margin-bottom: 0;">
                      <el-input
                        v-model="item.address"
                        placeholder="请选择地址"
                        readonly
                        @click.native="openAddressDialog(index)"
                        size="small"
                      >
                        <i slot="prefix" class="el-icon-location" style="cursor: pointer;"></i>
                        <i slot="suffix" class="el-icon-arrow-right" style="cursor: pointer;"></i>
                      </el-input>
                    </el-form-item>
                  </div>
                  <div class="sp-col sp-col-time">
                    <el-form-item :prop="`pickupAddressList.${index}.pickupTime`" style="margin-bottom: 0;">
                      <el-date-picker
                        v-model="item.pickupTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="请选择自提时间"
                        size="small"
                        style="width: 100%;"
                      ></el-date-picker>
                    </el-form-item>
                  </div>
                  <div class="sp-col sp-col-action">
                    <el-button type="text" icon="el-icon-minus" @click="removePickupAddress(index)" size="small" v-if="form.pickupAddressList.length > 1"></el-button>
                    <el-button type="text" icon="el-icon-plus" @click="addPickupAddress" size="small"></el-button>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="是否包邮：" prop="isPostage">
              <el-radio-group v-model="form.isPostage">
                <el-radio :label="1">包邮</el-radio>
                <el-radio :label="0">不包邮</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="活动时间：" prop="dateTime">
              <el-date-picker v-model="form.dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="佣金：" prop="commissionAmount">
              <div style="display:flex">
                <el-select v-model="form.commissionType" placeholder="请选择" clearable size="small" style="width: 110px">
                  <el-option label="%" :value="2"></el-option>
                  <el-option label="元" :value="1"></el-option>
                </el-select>
                <el-input v-model="form.commissionAmount" placeholder="请输入大区分佣比例/金额" />
              </div>
            </el-form-item>
            <el-form-item label="税收分类编码：">
                  <el-input v-model="form.taxCode" placeholder="请输入税收分类编码" />
            </el-form-item>
            <el-form-item label="正价商品：" class="width100" required>
              <gift-vue :form="form" :type="1" :isPackage="0" :isGoods="0" @update-retail-price="updateRetailPrice" />
            </el-form-item>
            <el-form-item label="赠品商品：" class="width100">
              <gift-vue :form="form" :type="0" :isPackage="0" :isGoods="0" @update-retail-price="updateRetailPrice" />
            </el-form-item>
            <!-- 服务配置 -->
            <!-- <div class="title-box"><span class="txt1">服务配置</span><span class="txt2">根据系统默认配置的，默认读取</span><span class="fr" @click="addService">添加服务</span></div>
              <service-vue :form="form" :bisicsInfo="bisicsInfo" /> -->
            <div class="title-box"><span class="txt1">权限</span></div>
            <!-- 权限 -->
            <jurisd-vue :form="form" :bisicsInfo="bisicsInfo" type="1" />

            <div class="title-box"><span class="txt1">活动详情</span></div>
            <el-form-item label="活动详情：" class="width100">
              <editor v-model="form.details" :min-height="240" :height="240" :uploadUrl="uploadUrl" />
            </el-form-item>
            <el-form-item label="商品排序：" class="width100">
              <el-input v-model="form.sort" placeholder="请输入商品排序" />
              <span>系统自动带出排序，并支持修改</span>
            </el-form-item>
            <el-form-item label="状态：" class="width100">
              <!-- 1 上架 2下架 -->
              <el-switch v-model="form.state" :active-value="1" :inactive-value="2"></el-switch>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="formVisible = false">
              取消
            </el-button>
            <el-button type="primary" @click="doCreate()">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 地址选择对话框 -->
    <map-component
      :positionDialog="addressDialogVisible"
      @updatePositionDialog="addressDialogVisible = $event"
      @handlePositionDialog="handleAddressSelected"
    ></map-component>
  </div>
</template>

<script>
import sysGoodsApi from '@/api/goods/sysGoods'
import sysGoodsShareApi from '@/api/goods/sysGoodsShare'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ImageUpload from "@/components/ImageUpload";
import MoreImageUpload from "@/components/MoreImageUpload";
import FileUpload from "@/components/FileUpload"
import Editor from "@/components/Editor";
import jurisdVue from '@/views/common/jurisd.vue';
import giftVue from '@/views/common/gift.vue'
import MapComponent from '@/components/map/index.vue'
import { guid, Subtr, accMul, generateCode } from '@/utils/index'
import sysAddrApi from '@/api/sys/sysAddr'
import technicianInfoApi from '@/api/technical/technicianInfo'
import clientListApi from '@/api/client/clientList'
import sysToolsApi from '@/api/sys/tools'
import { debounce } from 'lodash'
function initFormBean() {
  const formBean = {
    youCode: '',
    isMoreSpec: 0,
    uuid: null,
    name: null,
    sysGoodsCategorizeList: [],
    supplier: null,   //供应商
    virtualSalesCount: null,
    buyMinCount: 0,
    sendDay: 0,
    img: null,
    sysGoodsAreaList: [1],
    bannerImg: [],
    video: null,
    isControlTime: 0,
    dateTime: [],
    tag: '',
    sysGoodsRecommendList: [],
    details: null,
    qualification: null,
    quotaNum: null,
    isQuota: 0,
    retailPrice: '',
    isTopRecommend: 0,
    giftData: [{ goodsId: '', specValuecombineId: '', num: '', price: '' }],
    giftData1: [{ goodsId: '', specValuecombineId: '', num: '', price: '' }],
    isPackage: 1,
    sysGoodsShareList: [],
    salesNum: '',
    commissionType: '',
    commissionAmount: '',
    state: 2,
    inventory: 0,
    isShowApp: 1,
    canInvoice:0,
    isPostage: null,
    actualQuantity: 1,
    taxCode: '', // 税收分类编码
    isOpenMailing: false, // 是否开启邮寄
    isOpenSelfPickup: false, // 是否开启自提
    pickupMethodList: [], // 取件方式列表
    pickupAddressList: [{ name: '', address: '', provinceCode: '', cityCode: '', districtCode: '', latitude: '', longitude: '', pickupTime: '', writeoffAuthList: [] }], // 自提地址集合
    writeoffAuthList: [] // 核销授权集合
  }
  return formBean
}

export default {
  props: ['categorizeOptions'],
  components: { Editor, ImageUpload, Treeselect, MoreImageUpload, FileUpload, jurisdVue, giftVue, MapComponent },
  data() {
    return {
      categorizepProps: {
        label: 'name',
        value: 'id',
        children: 'child',
        multiple: true
      },
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      form: initFormBean(),
      formVisible: false,
      formRules: {
        // youCode: [{ required: true, message: '请输入聚水潭编码', trigger: 'blur' }],
        name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        retailPrice: [{ required: true, message: '请输入市场价格', trigger: 'blur' }],
        virtualSalesCount: [{ required: true, message: '请输入虚拟销售量', trigger: 'blur' }],
        salesNum: [{ required: true, message: '请输入秒杀分数', trigger: 'blur' }],
        commissionAmount: [{ required: true, message: '请输入大区分佣比例/金额', trigger: 'blur' }],
        img: [{ required: true, message: '请选择商品主图', trigger: 'change' }],
        dateTime: [{ required: true, message: '请选择上下架时间', trigger: 'change' }],
        quotaNum: [{ required: true, message: '请输入限购数量', trigger: 'blur' }],
        isQuota: [{ required: true, message: '选择是否限购', trigger: 'change' }],
        isShowApp: [{ required: true, message: '请选择是否APP端展示', trigger: 'change' }],
        canInvoice: [{ required: true, message: '请选择是否开票', trigger: 'change' }],
        isPostage: [{ required: true, message: '请选择是否包邮', trigger: 'change' }],
        pickupMethodList: [{ required: true, type: 'array', min: 1, message: '请选择取件方式', trigger: 'change' }],
      },
      bisicsInfo: null, //基本配置数据
      isRepSub: false,
      addressDialogVisible: false, // 地址选择对话框显示状态
      currentAddressIndex: 0, // 当前编辑的地址索引
      regionOptions: [], // 省市区选项
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
      },
      writeoffUserOptions: [], // 核销用户选项
      writeoffUserLoading: false, // 核销用户加载状态
      writeoffUserMap: {}, // 核销用户映射
      searchWriteoffUsersTimers: {}, // 防抖定时器映射
      searchWriteoffUsersRequests: {} // 正在进行的请求映射
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 150;
    this.getBisicsInfo()
    this.loadAddressData()
    
    // 为每个索引创建防抖搜索方法
    this.debouncedSearchWriteoffUsers = debounce(this._searchWriteoffUsers, 300)
  },
  computed: {
    allPrice() {
      let { giftData } = this.form;
      let price = 0;
      giftData.forEach(it => {
        price = Subtr(price, -accMul(it.num, it.price))
      })
      return price

    }
  },
  watch: {
    'form.isQuota'(newVal) {
      // 当选择不限购时，自动将限购数量设置为0
      if (newVal === 0) {
        this.form.quotaNum = 0
      }
    },
    'form.pickupMethodList'(newVal, oldVal) {
      // 当选择自提时，确保至少有一个默认的空行
      if (newVal && newVal.includes('selfPickup')) {
        if (!this.form.pickupAddressList || !Array.isArray(this.form.pickupAddressList) || this.form.pickupAddressList.length === 0) {
          this.$set(this.form, 'pickupAddressList', [{ name: '', address: '', provinceCode: '', cityCode: '', districtCode: '', latitude: '', longitude: '', pickupTime: '', writeoffAuthList: [], writeoffUserOptions: [], writeoffUserLoading: false }])
        }
      } else {
        // 如果取消选择自提，清空自提地址列表
        if (oldVal && oldVal.includes('selfPickup') && (!newVal || !newVal.includes('selfPickup'))) {
          this.$set(this.form, 'pickupAddressList', [])
        }
      }
      // 清除验证错误
      if (newVal && newVal.length > 0) {
        this.$nextTick(() => {
          if (this.$refs.dataForm) {
            this.$refs.dataForm.clearValidate('pickupMethodList')
            // 如果取消选择自提，清除自提地址的验证错误
            if (!newVal.includes('selfPickup')) {
              this.$refs.dataForm.clearValidate('pickupAddressList')
            }
          }
        })
      }
    }
  },
  methods: {
    /**
     * 更新零售价
     */
    updateRetailPrice(price) {
      // 处理零售价更新逻辑
      if (price !== undefined && price !== null) {
        this.form.retailPrice = price
      }
    },
    getBisicsInfo() {
      sysDataconstantApi.fetchBatchCode({ code: 'product_seckill_buy_auth,product_seckill_price_auth' }).then(({ data }) => {
        data.list.forEach(item => {
          item.content2 = item.content2 ? JSON.parse(item.content2) : ''
        });
        this.bisicsInfo = data.list
      })
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.child && !node.child.length) {
        delete node.child;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.child
      };
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate(total) {
      this.resetForm()
      this.form.sort = total + 1;
      this.form.youCode = generateCode()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      sysGoodsApi.fetchById(row.id).then(({ data }) => {
        this.form = data;
        this.calcEditData()
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      })
    },
    calcEditData() {
      let { listingStartTime, listingEndTime, bannerImg, sysGoodsPackageConfigShowList, sysGoodsSpecValuecombineList } = this.form;
      //上下架时间
      this.$set(this.form, 'dateTime', [listingStartTime, listingEndTime]);
      //banner图 
      this.$set(this.form, 'bannerImg', this.clacArrObj(bannerImg));
      //零售价
      this.$set(this.form, 'retailPrice', sysGoodsSpecValuecombineList[0].retailPrice);
      //聚水潭编码
      this.$set(this.form, 'youCode', sysGoodsSpecValuecombineList[0].jushuitanCode);
      //正价商品 赠品商品
      let arr = [], arr1 = []
      sysGoodsPackageConfigShowList.forEach(item => {
        if (item.isGift) arr.push(item)
        else arr1.push(item)
      })
      this.$set(this.form, 'giftData1', arr.length > 0 ? arr : [{ goodsId: '', specValuecombineId: '', num: '', price: '' }]);
      this.$set(this.form, 'giftData', arr1.length > 0 ? arr1 : [{ goodsId: '', specValuecombineId: '', num: '', price: '' }]);
      // 处理取件方式
      if (!this.form.pickupMethodList) {
        this.$set(this.form, 'pickupMethodList', [])
      }
      if (this.form.isOpenSelfPickup) {
        if (!this.form.pickupMethodList.includes('selfPickup')) {
          this.form.pickupMethodList.push('selfPickup')
        }
      }
      if (this.form.isOpenMailing) {
        if (!this.form.pickupMethodList.includes('express')) {
          this.form.pickupMethodList.push('express')
        }
      }
      // 自提地址列表：如果选择了自提且列表为空或不存在，至少有一个默认的空行
      if (this.form.isOpenSelfPickup) {
        if (!this.form.pickupAddressList || !Array.isArray(this.form.pickupAddressList) || this.form.pickupAddressList.length === 0) {
          this.$set(this.form, 'pickupAddressList', [{ name: '', address: '', provinceCode: '', cityCode: '', districtCode: '', latitude: '', longitude: '', pickupTime: '', writeoffAuthList: [], writeoffUserOptions: [], writeoffUserLoading: false }])
        } else {
          // 处理已存在的自提地址列表，确保每个地址项都有核销人相关的字段
          this.form.pickupAddressList.forEach(item => {
            // 确保有 writeoffAuthList 字段
            if (!item.writeoffAuthList) {
              this.$set(item, 'writeoffAuthList', [])
            }
            // 如果后端返回的是 writeoffAuthList，需要转换为选择器需要的格式
            if (item.writeoffAuthList && Array.isArray(item.writeoffAuthList) && item.writeoffAuthList.length > 0) {
              // 将后端格式转换为选择器需要的格式
              item.writeoffAuthList = item.writeoffAuthList.map(auth => ({
                userId: auth.userId || '',
                userInfoId: auth.userInfoId  || 0, // 保留 userInfoId，确保提交时不会丢失
                userRealName: auth.userRealName  || '',
                userMobile: auth.userMobile  || '',
                userLevelName: auth.userLevelName  || '',
                userType: auth.userType || 0
              }))
            }
            // 初始化临时字段
            if (!item.writeoffUserOptions) {
              this.$set(item, 'writeoffUserOptions', [])
            }
            // 将已选中的核销人数据添加到选项中，这样下拉框才能正确显示
            if (item.writeoffAuthList && Array.isArray(item.writeoffAuthList) && item.writeoffAuthList.length > 0) {
              // 合并已选中的项到选项中，避免重复
              const existingUserIds = new Set(item.writeoffUserOptions.map(opt => opt.userId))
              item.writeoffAuthList.forEach(auth => {
                if (auth.userId && !existingUserIds.has(auth.userId)) {
                  item.writeoffUserOptions.push(auth)
                  existingUserIds.add(auth.userId)
                }
              })
            }
            if (item.writeoffUserLoading === undefined) {
              this.$set(item, 'writeoffUserLoading', false)
            }
            // 确保 pickupTime 是字符串格式
            if (Array.isArray(item.pickupTime)) {
              this.$set(item, 'pickupTime', '')
            }
          })
        }
      }

    },
    clacArrObj(str) {
      if (!str) return []
      let arr = str.split(',')
      let newArr = []
      arr.forEach(item => {
        newArr.push({ url: item })
      })
      return newArr
    },
    calcJurisd(forArr) {
      let arr = []
      forArr.forEach(item => {
        if (item.isActive) arr.push(item.key)
      })
      return arr
    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      params.listingStartTime = params.dateTime[0]
      params.listingEndTime = params.dateTime[1]
      delete params.dateTime
      params.customerLevelBuyList = this.calcJurisd(params.customerLevelBuyList)
      params.customerLevelList = this.calcJurisd(params.customerLevelList)
      params.sysRoleList = this.calcJurisd(params.sysRoleList)
      params.technicalServiceLevelList = this.calcJurisd(params.technicalServiceLevelList)
      params.giftData.forEach(obj => { obj.isGift = 0; obj.num = +obj.num; obj.price = +obj.price || 0; delete obj.specArr })
      params.giftData1.forEach(obj => { obj.isGift = 1; obj.num = +obj.num; obj.price = 0; delete obj.specArr })
      let allGiftData = params.giftData.concat(params.giftData1)
      allGiftData.forEach((item, index) => {
        if (!item.goodsId && !item.specValuecombineId) allGiftData.splice(index, 1)
        if (item.goodsId && !item.specValuecombineId) item.specValuecombineId = 0
      })
      params.packageData = JSON.stringify(allGiftData)
      
      // 处理取件方式：将 pickupMethodList 转换为 isOpenSelfPickup 和 isOpenMailing
      params.isOpenSelfPickup = params.pickupMethodList && params.pickupMethodList.includes('selfPickup')
      params.isOpenMailing = params.pickupMethodList && params.pickupMethodList.includes('express')
      // 删除 pickupMethodList 字段
      delete params.pickupMethodList
      
      // 处理自提地址列表中的核销人信息
      if (params.pickupAddressList && Array.isArray(params.pickupAddressList)) {
        params.pickupAddressList = params.pickupAddressList.map((item, index) => {
          const newItem = { ...item }
          // 处理核销人信息：将选中的用户对象转换为后端要求的格式
          if (newItem.writeoffAuthList && Array.isArray(newItem.writeoffAuthList)) {
            newItem.writeoffAuthList = newItem.writeoffAuthList.map(user => {
              // 确保 userInfoId 正确传递
              // 如果 userInfoId 存在且不为空字符串，使用原值；否则尝试从 userId 获取，最后默认为 0
              let userInfoId = 0
              if (user.userInfoId !== undefined && user.userInfoId !== null && user.userInfoId !== '') {
                userInfoId = user.userInfoId
              } 
              return {
                goodsId: params.id || 0,
                pickupAddressId: newItem.id || 0, // 使用自提地址的id，新增时为0
                userId: user.userId || '',
                userInfoId: userInfoId,
                userType: user.userType || 0
              }
            })
          } else {
            newItem.writeoffAuthList = []
          }
          // 处理 pickupTime 时间格式：将 T 替换为空格
          if (newItem.pickupTime) {
            if (Array.isArray(newItem.pickupTime)) {
              newItem.pickupTime = ''
            } else if (typeof newItem.pickupTime === 'string') {
              // 将 ISO 格式的时间字符串中的 T 替换为空格
              newItem.pickupTime = newItem.pickupTime.replace('T', ' ')
            }
          }
          // 删除 operatedTime 字段
          delete newItem.operatedTime
          // 移除临时字段
          delete newItem.writeoffUserOptions
          delete newItem.writeoffUserLoading
          return newItem
        })
      }
      
      // 如果没有选择自提，清空自提地址列表
      if (!params.isOpenSelfPickup) {
        params.pickupAddressList = []
      }
      
      return params
    },
    doCreate() {
      console.log(this.calcParams())
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          // 如果选择了自提，验证自提地址列表必须至少有一条有效数据
          if (this.form.pickupMethodList && this.form.pickupMethodList.includes('selfPickup')) {
            if (!this.form.pickupAddressList || !Array.isArray(this.form.pickupAddressList) || this.form.pickupAddressList.length === 0) {
              return this.$message.error('请至少添加一条自提地址信息')
            }
            // 验证每条自提地址的必填项
            for (let i = 0; i < this.form.pickupAddressList.length; i++) {
              const item = this.form.pickupAddressList[i]
              if (!item.name || !item.name.trim()) {
                return this.$message.error(`第${i + 1}条自提地址的活动名称不能为空`)
              }
              if (!item.address || !item.address.trim()) {
                return this.$message.error(`第${i + 1}条自提地址的地址不能为空`)
              }
            }
          }
          
          let params = this.calcParams()
          console.log(params)
          if (!params.customerLevelBuyList.length) return this.$message.error('请选择购买权限')
          if (!params.customerLevelList.length && !params.sysRoleList.length && !params.technicalServiceLevelList.length) return this.$message.error('请选择查看权限')
          params.bannerImg = params.bannerImg.length ? params.bannerImg.map(banner => banner.url).toString() : ''
          params.specData = JSON.stringify([{ actualQuantity: 1, id: params.id ? params.sysGoodsSpecValuecombineList[0].id : 0, jushuitanCode: params.youCode, retailPrice: params.retailPrice, specDetail: "", aliasTitle: "", orderNo: 0, specImg: "" }])
          this.submitGoods(params)
        }
      });
    },
    submitGoods(params) {
      params.virtualSalesCount = +params.virtualSalesCount || 0
      params.buyMinCount = +params.buyMinCount || 0
      // 如果是不限购，限购数量强制设置为0
      params.quotaNum = params.isQuota === 0 ? 0 : (+params.quotaNum || 0)
      params.sort = +params.sort || 0
      delete params.giftData
      delete params.giftData1
      if (this.isRepSub) return
      this.isRepSub = true
      if (params.id > 0) {
        sysGoodsApi.update(params).then((data) => {
          this.postCallback(data)
        }).catch(res => {
          this.isRepSub = false
        });
      } else {
        params.uuid = guid()
        sysGoodsApi.create(params).then((data) => {
          this.postCallback(data)
        }).catch(res => {
          this.isRepSub = false
        });
      }
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    //添加服务
    // addService() {
    //   let find = this.bisicsInfo.find(item => item.code === 'goods_services')
    //   this.$refs.basicsAdd.handleUpdate(find)
    // }
    /**
     * 加载地址数据
     */
    loadAddressData() {
      // 如果需要加载地址数据，可以在这里实现
    },
    /**
     * 添加自提地址
     */
    addPickupAddress() {
      this.form.pickupAddressList.push({
        name: '',
        address: '',
        provinceCode: '',
        cityCode: '',
        districtCode: '',
        latitude: '',
        longitude: '',
        pickupTime: '',
        writeoffAuthList: [],
        writeoffUserOptions: [],
        writeoffUserLoading: false
      })
    },
    /**
     * 删除自提地址
     */
    removePickupAddress(index) {
      if (this.form.pickupAddressList.length > 1) {
        this.form.pickupAddressList.splice(index, 1)
      }
    },
    /**
     * 打开地址选择对话框
     */
    openAddressDialog(index) {
      this.currentAddressIndex = index
      this.addressDialogVisible = true
    },
    /**
     * 处理地址选择
     */
    handleAddressSelected(addressData) {
      if (addressData && this.form.pickupAddressList && this.form.pickupAddressList[this.currentAddressIndex]) {
        const address = this.form.pickupAddressList[this.currentAddressIndex]
        // map-component 返回的数据格式：{ mapText, latitude, longitude }
        address.address = addressData.mapText || addressData.address || ''
        address.latitude = addressData.latitude || ''
        address.longitude = addressData.longitude || ''
        // 如果返回了省市区代码，则使用，否则留空（可以后续通过地址解析获取）
        address.provinceCode = addressData.provinceCode || ''
        address.cityCode = addressData.cityCode || ''
        address.districtCode = addressData.districtCode || ''
        // 关闭地址选择对话框
        this.addressDialogVisible = false
      }
    },
    /**
     * 搜索核销用户（防抖包装）
     * @param {String} query - 搜索关键词
     * @param {Number} index - 当前行的索引
     */
    searchWriteoffUsers(query, index) {
      // 清除之前的定时器
      const timerKey = `search_${index}`
      if (this.searchWriteoffUsersTimers[timerKey]) {
        clearTimeout(this.searchWriteoffUsersTimers[timerKey])
      }
      
      // 如果查询为空，立即清空选项
      if (!query || query.trim() === '') {
        if (this.form.pickupAddressList && this.form.pickupAddressList[index]) {
          this.$set(this.form.pickupAddressList[index], 'writeoffUserOptions', [])
        }
        return
      }
      
      // 使用防抖延迟执行
      this.searchWriteoffUsersTimers[timerKey] = setTimeout(() => {
        this._searchWriteoffUsers(query, index)
      }, 300)
    },
    /**
     * 实际执行搜索核销用户的方法
     * @param {String} query - 搜索关键词
     * @param {Number} index - 当前行的索引
     */
    async _searchWriteoffUsers(query, index) {
      if (!this.form.pickupAddressList || !this.form.pickupAddressList[index]) {
        return
      }
      
      const item = this.form.pickupAddressList[index]
      
      // 初始化选项数组和加载状态
      if (!item.writeoffUserOptions) {
        this.$set(item, 'writeoffUserOptions', [])
      }
      if (item.writeoffUserLoading === undefined) {
        this.$set(item, 'writeoffUserLoading', false)
      }
      
      if (query !== '') {
        // 检查是否有相同查询的请求正在进行
        const requestKey = `${index}_${query}`
        if (this.searchWriteoffUsersRequests[requestKey]) {
          // 如果已有相同请求在进行，直接返回
          return
        }
        
        // 标记请求开始
        this.searchWriteoffUsersRequests[requestKey] = true
        this.$set(item, 'writeoffUserLoading', true)
        
        try {
          // 使用统一的用户信息列表接口搜索核销人员
          const res = await sysToolsApi.userInfoList({
            keywords: query,
            pageNo: 1,
            pageSize: 10
          }).catch(() => ({ data: { list: [] } }))
          
          // 处理返回的数据
          const allUsers = ((res.data && res.data.list) || []).map(user => ({
            userId: user.userId || '',
            userInfoId: user.userInfoId  || '',
            userRealName: user.userRealName  || '',
            userMobile: user.userMobile  || '',
            userLevelName: user.userLevelName  || '',
            userType: user.userType || 0
          }))
          
          // 使用 $set 确保响应式更新
          this.$set(item, 'writeoffUserOptions', allUsers)
        
        } catch (error) {
          
          this.$set(item, 'writeoffUserOptions', [])
        } finally {
          // 清除请求标记
          delete this.searchWriteoffUsersRequests[requestKey]
          this.$set(item, 'writeoffUserLoading', false)
        }
      } else {
        this.$set(item, 'writeoffUserOptions', [])
      }
    },
    /**
     * 处理核销权限变化
     */
    handleWriteoffAuthChange(value) {
      // 处理核销权限变化逻辑
    }
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.reimbursement {
  // padding: 0 20px;
}
.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}
.table-list {
  border: 1px solid #e4e4e4;

  .sp-col {
    flex: 1;
    color: #666;
    /* min-height: 40px; */
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;
   /* padding: 5px; */
    width: 100%;
    &.flex2 {
      flex: 2;
      min-width: 200px;
    }
    // 活动名称列
    &.sp-col-name {
      flex: 1;
      min-width: 100px;
    }
    // 核销人信息列
    &.sp-col-writeoffAuthNameList {
      flex: 2;
      min-width: 200px;
      align-items: flex-start; // 从顶部对齐，允许行高自适应
      ::v-deep .writeoff-select {
        .el-select__input-wrapper {
          max-height: none;
        }
        .el-select__tags {
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
          max-height: none;
          overflow: visible;
          min-height: 32px;
        }
        .el-tag {
          margin: 2px 4px 2px 10px;
          white-space: normal;
          word-break: break-all;
        }
        .el-select__input {
          flex: 0 0 auto;
          min-width: 100px;
        }
        .el-input__inner {
          height: auto;
          min-height: 32px;
        }
      }
    }
    // 自提地址列 - 占用更多空间
    &.sp-col-address {
      flex: 3;
      min-width: 200px;
    }
    // 自提时间列
    &.sp-col-time {
      flex: 1.5;
      min-width: 200px;
    }
    // 操作列 - 固定宽度
    &.sp-col-action {
      flex: 0 0 100px;
      width: 100px;
      min-width: 100px;
      max-width: 100px;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-form-item{
        width: 100%;
      }
      .el-input {
        ::v-deep .el-input__inner {
          align-self: auto; /* 重置对齐方式 */
          flex: none; /* 重置 flex 属性 */
          border: none;
          text-align: left;
          // padding-left: 30px;
          // padding-right: 30px;
          // overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      
      .el-date-editor {
        ::v-deep .el-input__inner {
          text-align: left;
          padding-left: 10px;
          padding-right: 10px;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.item-flex {
  display: flex;
  margin-bottom: 5px;
  .icon-box {
    display: inline-block;
    width: 60px;
    i {
      font-size: 20px;
      margin-left: 5px;
      cursor: pointer;
      font-weight: bold;
      color: #465c99;
    }
  }
}
.oper-icon {
  i {
    font-size: 16px;
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
    color: #465c99;
  }
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.hint {
  font-size: 12px;
  color: #878787;
  &.hint1 {
    padding-left: 10px;
    line-height: 18px;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-left: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
.title-box {
  margin-bottom: 10px;
  margin-right: 24px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 30px;
    &::before {
      content: '';
      position: absolute;
      left: 20px;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
  }
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
</style>
